import { getSocialConnector } from '@lib/social/scheduling/platforms';
import type { SocialConnection } from '@stores/SocialConnections';
import classNames from 'classnames';
import css from './SocialAccountAvatar.module.scss';

/** A connected account's picture (or initial) with its platform's logo badged on it. */
export function SocialAccountAvatar({
  connection,
  className,
}: {
  connection: SocialConnection;
  className?: string;
}) {
  const connector = getSocialConnector(connection.platform);
  const name = connection.displayName ?? connector?.label ?? connection.platform;
  return (
    <div className={classNames(css.avatarWrap, className)}>
      <div className={css.avatar}>
        {connection.avatarUrl ? (
          <img src={connection.avatarUrl} alt="" />
        ) : (
          <span className={css.avatarInitial}>{name.charAt(0).toUpperCase()}</span>
        )}
      </div>
      {connector && (
        <span className={css.platformBadge} title={connector.label}>
          {connector.icon}
        </span>
      )}
    </div>
  );
}
